import { NgModule } from '@angular/core';
import { BrowserModule }  from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslationsModule } from '@symplicity/syng';
import { CountdownModule } from 'ngx-countdown';
import { EscapeHtmlPipe } from './common/keep-html.pipe';
import { MomentModule, DateFormatPipe, IsAfterPipe, IsBeforePipe } from 'ngx-moment';

import { AppComponent } from './app.component';
import { GlobalService } from './common/services/global.service';
import { BackendService } from './common/services/backend.service';
import { PicklistService } from './common/services/picklist.service';
import { RatingsComponent } from './common/ratings.component';
import { FactoryService } from './common/services/factory.service';
import { VolumeMeterComponent } from './common/volume-meter.component';
import { HtmlFormatterService } from './common/utils/html-formatter.service';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';

import { StartComponent } from './student/interview/start.component';
import { RecordingResponseComponent } from './student/interview/recording-response.component';
import { ReplayResponseListComponent } from './student/interview/replay-responses.component';
import { ManagerReplayResponseListComponent } from './manager/mgr-replay-responses.component';
import { ReviewerComponent } from './student/interview/reviewer.component';
import { ManagerReviewerComponent } from './manager/mgr-reviewer.component';
import { ManagerReviewerFeedbackModalComponent } from './manager/mgr-reviewer-feedback-modal.component';
import { FeedbackComponent } from './common/feedback.component';
import { StreamComponent } from './common/stream.component';
import { MenuButtonComponent } from './common/menu-button.component';
import { ToggleButtonComponent } from './common/toggle-button.component';
import { StarsRatingComponent } from './common/stars-rating.component';
import { RequestFeedbackComponent } from './student/interview/request-feedback.component';
import { FeedbackSentComponent } from './student/interview/feedback-sent.component';
import { ReviewInterviewComponent } from './student/interview/review-interview.component';
import { WelcomeComponent } from './student/interview/welcome.component';
import { BeginInterviewComponent } from './student/interview/begin-interview.component';
import { EndInterviewComponent } from './student/interview/end-interview.component';
import { PracticeCompleteComponent } from './student/interview/practice-complete.component';
import { InterviewCompleteComponent } from './student/interview/interview-complete.component';
import { InterviewComponent } from './student/interview/interview.component';
import { InterviewSettingsComponent } from './student/interview/interview-settings.component';
import { SampleQuestionComponent } from './student/interview/sample-question.component';
import { ShareInterviewComponent } from './student/interview/share-interview.component';
import { DeleteInterviewComponent } from './student/interview/delete-interview.component';
import { FeedbackListComponent } from './student/interview/feedback-list.component';
import { InterviewWrapperComponent } from './student/interview/interview-wrapper.component';

import { appRoutes }   from './routes';

import { InterviewStreamService } from './student/interview/services/interview.service';
import { InterviewDataService } from './student/interview/services/interview-data.service';

import { SharedReviewerService } from './shared-reviewer.service';

@NgModule({ declarations: [
        AppComponent,
        WelcomeComponent,
        RecordingResponseComponent,
        BeginInterviewComponent,
        EndInterviewComponent,
        SampleQuestionComponent,
        PracticeCompleteComponent,
        InterviewComponent,
        InterviewCompleteComponent,
        InterviewSettingsComponent,
        ReplayResponseListComponent,
        ManagerReplayResponseListComponent,
        ShareInterviewComponent,
        DeleteInterviewComponent,
        RatingsComponent,
        StreamComponent,
        ReviewerComponent,
        ManagerReviewerComponent,
        ManagerReviewerFeedbackModalComponent,
        ReviewInterviewComponent,
        FeedbackComponent,
        RequestFeedbackComponent,
        EscapeHtmlPipe,
        StartComponent,
        VolumeMeterComponent,
        FeedbackSentComponent,
        MenuButtonComponent,
        ToggleButtonComponent,
        StarsRatingComponent,
        FeedbackListComponent
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        FormsModule,
        RouterModule.forRoot(appRoutes, {}),
        NgbModule,
        NgSelectModule,
        TranslationsModule.forRoot(),
        CommonModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        CountdownModule,
        ReactiveFormsModule,
        MomentModule,
        InterviewWrapperComponent
    ],
    providers: [
        GlobalService,
        BackendService,
        PicklistService,
        FactoryService,
        InterviewStreamService,
        InterviewDataService,
        HtmlFormatterService,
        DatePipe,
        DateFormatPipe,
        IsAfterPipe,
        IsBeforePipe,
        SharedReviewerService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
